"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TCP_MAX_SESSION_MS_DEFAULT = void 0;
/**
 * TCP 연결 절대 수명 기본값(ms) — 서버 `TCP_MAX_SESSION_MS`의 기본값이자, 수신 중(`RECEIVING`)
 * 로그 파일을 "끊긴 업로드"로 보고 지울 수 있게 되는 경과 시간이다.
 * 연결이 이 시간을 넘겨 살아 있을 수 없으므로 그만큼 지난 수신 중 행은 다시 이어지지 않는다.
 * 서버 삭제 판정과 관리자 웹 삭제 버튼이 같은 답을 내야 해서 런타임으로 반입한다
 * (2026-10-02 30분 → 60분 상향 때 화면 쪽 하드코딩 30분이 갈라질 뻔했다).
 * 60분 산정 근거는 서버 `tcp/tcp-session.ts`의 `DEFAULT_SESSION_OPTIONS` 표.
 */
exports.TCP_MAX_SESSION_MS_DEFAULT = 60 * 60 * 1000;
